export default __webpack_public_path__ + "static/media/pm.b0e22e82.svg";